import { SplatProposal } from "../../../amplify/backend/function/OfferExpContacts/ts/public/types";
import { Proposal, UltimateParentProposal } from "cap/capTypes";

const getBaseProposalId = (pId: string = "") => {
  if (pId.includes(":")) {
    return pId.split(":")[0];
  }
  return pId.split("-")[0];
};

const isSignedProposal = (
  activeProposal: Proposal | undefined,
  originalProposal: SplatProposal | undefined,
  ultimateParentProposal: UltimateParentProposal | undefined
): boolean => {
  const parentProposalSigned =
    originalProposal?.signed &&
    getBaseProposalId(activeProposal?.proposalId) ===
      getBaseProposalId(originalProposal?.proposalId);

  const ultimateProposalSigned =
    ultimateParentProposal?.signed &&
    ultimateParentProposal?.externalId &&
    getBaseProposalId(activeProposal?.proposalId) ===
      getBaseProposalId(ultimateParentProposal?.externalId);

  return (
    !!activeProposal?.signed ||
    (!!activeProposal?.changeOrder &&
      (parentProposalSigned || !!ultimateProposalSigned))
  );
};

export { getBaseProposalId, isSignedProposal };
